var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5684 1.39399C19.9827 0.808204 19.0329 0.808205 18.4471 1.39399L10.9188 8.92228L3.80648 1.80993C3.22069 1.22414 2.27094 1.22414 1.68516 1.80993C1.09937 2.39571 1.09937 3.34546 1.68516 3.93125L8.79751 11.0436L1.39399 18.4471C0.808204 19.0329 0.808204 19.9827 1.39399 20.5684C1.97978 21.1542 2.92953 21.1542 3.51531 20.5684L10.9188 13.1649L18.7383 20.9844C19.3241 21.5702 20.2738 21.5702 20.8596 20.9844C21.4454 20.3986 21.4454 19.4489 20.8596 18.8631L13.0402 11.0436L20.5684 3.51531C21.1542 2.92952 21.1542 1.97978 20.5684 1.39399Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d05122248485743b456212e3be242420.svg";
export { ForwardRef as ReactComponent };